// extracted by mini-css-extract-plugin
export default {"wrapper":"PageLoader_wrapper__3tAXE","card":"PageLoader_card__ruI32"};